<template>
  <div class="debt">
    <div class="search">
      <mu-form :model="form" label-width="80" class="form" :inline="true">
        <mu-form-item prop="search" label="开始时间" label-position="left">
          <mu-date-input container="dialog" v-model="form.startTime"></mu-date-input>
        </mu-form-item>
        <mu-form-item prop="search" label="结束时间" label-position="left">
          <mu-date-input container="dialog" v-model="form.endTime"></mu-date-input>
        </mu-form-item>
        <mu-form-item class="search-btn">
          <mu-button color="primary" @click="getUnpaidOrder">
            <mu-icon left value="search" :size="20"></mu-icon>
            搜索
          </mu-button>
          <mu-button
            color="secondary"
            @click="download"
            v-loading="downloadLoading"
          >
            <mu-icon left value="archive" :size="20"></mu-icon>
            下载
          </mu-button>
        </mu-form-item>
      </mu-form>
    </div>

    <mu-data-table
      :columns="columns"
      :data="list"
      class="table"
      :loading="loading"
    >
      <template slot-scope="scope">
        <td>
          {{
            scope.row.customer.company
              ? scope.row.customer.company + '-' + scope.row.customer.realName
              : scope.row.customer.realName
          }}
        </td>
        <td>{{ scope.row.sum.value() }}</td>
        <td>{{ scope.row.paid.value() }}</td>
        <td>{{ scope.row.unpaid.value() }}</td>
      </template>
    </mu-data-table>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
import numeral from 'numeral'
import moment from 'moment'
export default {
  data() {
    return {
      form: {
        startTime: moment('2019-01-01').toDate(),
        endTime: moment().endOf('year').toDate(),
        getAll: true,
        relations: ['order.customer']
      },
      list: [],
      columns: [
        {
          title: '姓名'
        },
        {
          title: '总订单额'
        },
        {
          title: '已付款'
        },
        {
          title: '欠款金额'
        }
      ],
      loading: false,
      downloadLoading: false
    }
  },
  methods: {
    getAll() {
      this.getUnpaidOrder()
    },
    getUnpaidOrder() {
      this.loading = true
      backend(api.order.getAll, this.form).then((result) => {
        this.loading = false
        if (result.statusCode === 200) {
          const list = []
          const sumTotal = numeral(0)
          const paidTotal = numeral(0)
          const unpaidTotal = numeral(0)
          result.data.rows.forEach((item) => {
            const exist = list.find((x) => x.customer.id === item.customer.id)
            sumTotal.add(item.sum)
            paidTotal.add(item.paid)
            unpaidTotal.add(item.sum).subtract(item.paid)
            if (exist) {
              exist.orders.push(item)
              exist.sum.add(item.sum)
              exist.paid.add(item.paid)
              exist.unpaid.add(item.sum).subtract(item.paid)
            } else {
              list.push({
                customer: item.customer,
                orders: [item],
                sum: numeral(0).add(item.sum),
                paid: numeral(0).add(item.paid),
                unpaid: numeral(0).add(item.sum).subtract(item.paid)
              })
            }
          })
          list.push({
            customer: {
              company: '',
              realName: '合计'
            },
            sum: sumTotal,
            paid: paidTotal,
            unpaid: unpaidTotal
          })
          this.list = list
        }
      })
    },
    download() {
      backend(api.order.downloadDebt, this.form).then((result) => {
        if (result.statusCode === 200) {
          window.open(result.data.url, '_blank')
        }
      })
    }
  },
  mounted() {
    this.getUnpaidOrder()
  }
}
</script>

<style lang="less" scoped>
.debt {
  .card {
    .card-content {
      padding: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/reporter/debt.vue